// extracted by mini-css-extract-plugin
export var closeBtn = "sidebar-module--close-btn--ejWYk";
export var linksContainer = "sidebar-module--links-container--3tcAW";
export var showSidebar = "sidebar-module--showSidebar--gA4A8";
export var sidebar = "sidebar-module--sidebar--XogUW";